import { makeStyles, createStyles } from '@material-ui/core';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { TranquiTheme } from '../../containers/App/theme';
import useDictionary from '../../dictionaries/context/useDictionary';
import Stepper, { StepDataType } from './Stepper';

const routesForSteps: { [key: string]: number } = {
  resumen: 1,
  confirmacion: 2,
};

function NegotiationFlowStepper() {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const { gT } = useDictionary();

  const initialStepValues = React.useMemo(() => [
    {
      title: `${gT('general_stepper_0_title')}`,
      label: `${gT('general_stepper_0_label')}`,
      route: `${gT('general_stepper_0_route')}`,
    }, {
      title: `${gT('general_stepper_1_title')}`,
      label: `${gT('general_stepper_1_label')}`,
      route: `${gT('general_stepper_1_route')}`,
    }, {
      title: `${gT('general_stepper_2_title')}`,
      label: `${gT('general_stepper_2_label')}`,
      route: `${gT('general_stepper_2_route')}`,
    },
  ], [ gT ]);

  const [ steps, setSteps ] = React.useState<StepDataType[ ]>(initialStepValues);
  const [ stepSelected, setStepSelected ] = React.useState<number>(0);
  const { debtId, step: stepRoute } = useParams<{ debtId: string, step?: string }>();

  React.useEffect(() => {
    setSteps(initialStepValues.map((item) => ({ ...item, route: stepSelected === 2 ? '' : item.route.replace('debtId', debtId) })));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ debtId, stepSelected ]);

  React.useEffect(() => {
    if (!stepRoute) setStepSelected(0);
    if (!!stepRoute) setStepSelected(routesForSteps[stepRoute]);
  }, [ stepRoute ]);

  return (
    <Stepper
      title={`${gT(`general_stepper_${stepSelected}_title`)}`}
      steps={steps}
      alternativeLabel
      activeStep={stepSelected}
      className={classes.root}
      isNavigated
      dataTest="cy-negotiationFlow-stepper"
    />
  );
}

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default NegotiationFlowStepper;
